"use client";
import React from 'react';
import { DeviceInfoContext } from '../providers/DeviceInfoProvider.js';

/**
 * React hook that help checking user device
 *
 * @example
 * ```javascript
 * const isMobile = useIsMobile()
 * const isTablet = useIsTablet()
 * const isPhone = useIsPhone()
 * const isAppleMobile = useIsAppleMobile()
 * ```
 */
function useDeviceInfoContext() {
    return React.useContext(DeviceInfoContext);
}
function useIsPhone() {
    const { phone } = useDeviceInfoContext();
    return phone;
}
function useIsTablet() {
    const { tablet } = useDeviceInfoContext();
    return tablet;
}
function useIsMobile() {
    const { phone, tablet } = useDeviceInfoContext();
    return phone || tablet;
}
function useIsAppleMobile() {
    const { isAppleMobile } = useDeviceInfoContext();
    return isAppleMobile;
}

export { useDeviceInfoContext, useIsAppleMobile, useIsMobile, useIsPhone, useIsTablet };
//# sourceMappingURL=useDeviceInfo.js.map
